<template>
<div class="modal fade" ref="LookupModal" :id="`modal-${element.id}-${ rowIndex !== undefined ? rowIndex : '' }`" tabindex="-1" role="dialog" aria-labelledby="modalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">{{ element.title }}</h5>
            <button type="button" @click="close" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <div class="input-group mb-3">
                <div class="input-group-prepend">
                    <span class="input-group-text" id="search-addon"><i class="fas fa-search"></i></span>
                </div>
                <input ref="focusSearch" type="text" class="form-control" v-model="searchKey" placeholder="Search your data here" aria-label="Username" aria-describedby="search-addon">
                <button type="button" class="btn btn-outline-info" v-if="element.type === 'selectable-table'" data-dismiss="modal" @click="pickMultiple">Pick(s)</button>
            </div>
            <div class="table-responsive">
                <table class="table table-hover">
                    <thead class="thead-dark">
                        <tr v-if="element.dtElements">
                            <th v-if="element.type === 'selectable-table'" :key="'head-select'">Select</th>
                            <th v-for="head in visibleDtElements" :key="head.id">{{ head.title }}</th>
                        </tr>
                    </thead>
                    <tbody v-if="element.type !== 'selectable-table'">
                        <tr v-for="(data, rowIndex) in filteredCollection" :data-dismiss="autoClose ? 'modal' : '' " :key="rowIndex" @click.prevent="selectRow(data)">
                            <td v-for="(element, colIndex) in visibleDtElements" :key="colIndex" >
                                <div>{{ (element.type === 'date') ? moment(data[element.column]).format('L') : (element.type === 'number')  ? numeral(data[element.column]).format('0,0') : (element.type === 'currency') ? 'Rp ' + numeral(data[element.column]).format('0,0.00') : data[element.column] }}</div>
                            </td>
                        </tr>
                    </tbody>
                    <tbody v-if="element.type === 'selectable-table'">
                        <tr v-for="(data, rowIndex) in filteredCollection" :key="rowIndex">
                            <td :key="`select-${rowIndex}`" >
                                <input type="checkbox" :value="data.id" v-model="selectedRows" :id="`select-${data.id}`">
                            </td>
                            <td v-for="(element, colIndex) in visibleDtElements" :key="colIndex" >
                                <div>{{ (element.type === 'date') ? moment(data[element.column]).format('L') : (element.type === 'number')  ? numeral(data[element.column]).format('0,0') : (element.type === 'currency') ? 'Rp ' + numeral(data[element.column]).format('0,0.00') : data[element.column] }}</div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        </div>
    </div>
</div>
</template>

<script>
import api from '../services/api'

export default {
    props: ['element', 'rowIndex'],
    data() {
        return {
            searchKey: '',
            collections: [], 
            autoClose: this.element.needAutoClose === false ? false : true,
            selectedRows: [],
        }
    },
    computed: {
        filteredCollection() {
            return this.collections.filter(x =>
                this.element.filter.some(el => x[el].toLowerCase().includes(this.searchKey.toLowerCase()))
            )
        },
        visibleDtElements() {
            if (!this.element.dtElements) return [];
            // hide by flag
            return this.element.dtElements.filter(el => !el.hidden);
            // or hide by specific column name:
            // return this.element.dtElements.filter(el => el.column !== 'col5');
        }
    },
    mounted(){
        $(this.$refs.LookupModal).on('hidden.bs.modal', this.close);
        this.setFocus()
    },
    methods: {
        selectRow(data) {
            this.$emit('selectedRow', data)
        },
        close() {
            this.collections.splice(0, this.collections.length)
        },
        setFocus() {
            this.$refs.focusSearch.focus()
            console.log(this.$refs.focusSearch)
        },
        async fetchCollectionData(apiUrl) {
            const lookupApi = api(apiUrl)
            const result = await lookupApi.get()
            this.collections.splice(0, this.collections.length, ...result)
        },
        async fetchCollectionDataByParams({ apiUrl, query }) {
            const lookupApi = api(apiUrl)
            const result = await lookupApi.getWithQuery(query)
            this.collections.splice(0, this.collections.length, ...result)
        },
        async fetchCollectionDataByParamsPost({ apiUrl, payload }) {
            const lookupApi = api(apiUrl)
            const result = await lookupApi.createWithResult(payload)
            await this.collections.splice(0, this.collections.length, ...result)
        },
        pickMultiple() {
            const multipleResult = this.selectedRows.map(row => {
                const nameExist = this.collections.find(c => c.id === row)
                if (nameExist) {
                    return nameExist
                }
            })
            this.$emit('selectedRow', multipleResult)
        }
        // triggerHidden() {
        //     // if( $('#awbModal').length ){
        //     //     $('#awbModal').on('hidden.bs.modal', function(){
        //     //         //catch the native bootstrap close event and trigger yours
        //     //         // this.$emit('modal-close');
        //     //         console.log('catch closed')
        //     //         this.collections.splice(0, this.collections.length)
        //     //     });
        //     // }
        //     this.collections.splice(0, this.collections.length)
        //     // alert('hidden')
        // }
    }
}
</script>